<template>


 <div class="animated fadeIn">

  <transition name="fade">
    <CCard v-if="show" accentColor="primary">
     
      <CCardHeader color="gradient-light">
          <!-- <CLink class="card-header-action btn-minimize" @click="isCollapsed = !isCollapsed"> -->
        <span @click="isCollapsed = !isCollapsed" class="header-collapsed">
          <i class="fa fa-search mr-1"></i> Filtros
        </span>

        <div class="card-header-actions">
          <CLink class="card-header-action btn-minimize" @click="isCollapsed = !isCollapsed">
            <CIcon :name="`cil-chevron-${!isCollapsed ? 'bottom' : 'top'}`"/>
          </CLink>

        </div>
        <!-- </CLink> -->
      </CCardHeader>
       

      <CCollapse :show="!isCollapsed" :duration="400">
        <CCardBody class="form-mimoto">
          <CRow class="mb-2" >
            <!-- Rango fechas -->
            <CCol md="6">
              <div class="pb-2">
                <label for="name">Rango de fechas</label>
                  <date-picker
                  v-model="filtro.dates"
                  id="filter_dates" name="filter_dates"
                  type="date"
                  value-type="YYYY-MM-DD"
                  format="DD/MM/YYYY"
                  :lang="lang"
                  :range="true"
                  placeholder="Selecciona fecha de inicio y fin"
                  >
                </date-picker>
              </div>
            </CCol>


            <!-- Parkings -->
            <CCol md="6">
              <div role="group" class="form-group">

                <label v-if="multipleParking" for="parkings">Selecciona los parkings</label>
                <label v-else for="parkings">Parking</label>

                  <multiselect
                    v-model="parkingsSelected"
                    :options="parkingList"
                    :multiple="multipleParking"
                    :loading="loadingParking"
                    label="label"
                    track-by="label"
                    placeholder="Escribe para buscar un parking"
                    tag-placeholder="Añade un nuevo parking"
                    deselectLabel="Pulsa Enter para eliminar"
                    selectedLabel="Seleccionado"
                    selectLabel="Pulsa Enter para seleccionar"
                    class="select-tags"
                    :showNoResults="true"
                  >
                  <span slot="noResult">No hay resultados con ese texto. Considera cambiar el texto.</span>
                  <span slot="noOptions">Lista vacía</span>
                  </multiselect>

              </div>

            </CCol>

          </CRow>

        </CCardBody>

        <CCardFooter>

          <CRow class="d-flex justify-content-end filter-button-container">
            <CCol col="12" md="6">
              <CButton color="primary" @click="filtrarItems"
              class="filter-button" > Buscar
              </CButton >

              <button type="button" @click="borrarFiltro"
              class="filter-button-reset btn btn-outline-primary"
              >Restablecer</button >
            </CCol>
          </CRow>

        </CCardFooter>

      </CCollapse>

    </CCard>
  </transition>

  <toast ref="toast"></toast>

 </div>

</template>

<script>

import {
  PAYMENT_STATUS,
  CALENDAR_LANG,
  PLANS_CLIENTS_STATUS,
  TRIAL_STATUS,
  PLANS_CLIENTS_BASE_STATUS,
  STAYING_TYPES,
  DATA_FILTER,
  EVENT_TYPES,
  CARD_READER_TYPES,
} from "@/config";

import { fetchAllParkings } from "@/app/shared/global/services/global-service";

export default {
  name: 'PlansFilter',
  components: {
  },
  props: {
    // element: { type: String },
    title: { type: String, default: 'Filtros'},
    multipleParking: { type: Boolean, default: false },
    showFilter: { type: Boolean, default: false },
    filterType: { // product / stay
      type: String ,
      // required: true,
      default: 'product',
      validator: propValue => {
        const listOfAvailableExt = ['stay', 'product'];
        const isValidExt = listOfAvailableExt.includes(propValue);
        return isValidExt;
      }
    },

  },
  created() {
    this.getData();

    this.isCollapsed = this.showFilter ? false : true;
  },
  data(){
    return {
      showExtraOptions: false,
      show: true,
      isCollapsed: false, //window.screen.width <= 430 ? true: false,
      filtro: {...DATA_FILTER},
      filtroOptions: '',
      lang: CALENDAR_LANG,
      paymentStatus: [
       { value: null, label: ' - Seleccionar -'},
       ...PAYMENT_STATUS
      ],
      plansStatus: [ { value: null, label: ' - Seleccionar -'} ],
      trialStatus: [
       { value: null, label: ' - Seleccionar -'},
       ...TRIAL_STATUS
      ],
      eventTypes: [
       { value: null, label: ' - Seleccionar -'},
       ...EVENT_TYPES
      ],
      cardReaderTypes: [
       { value: null, label: ' - Seleccionar -'},
       ...CARD_READER_TYPES
      ],
      clientsList: [],
      parkingList: [],
      plansList: [{ value: null, label: ' - Seleccionar -'}],
      loadingClient: false,
      loadingParking: false,
      parkingsSelected: null,
    }
  },
  methods:{
    getData() {
      this.getParkings();
    },

    filtrarItems(){

      let query = '';

      Object.keys(this.filtro).forEach( key => {

        if (!!this.filtro[key]) {

          if (key == 'created_at') {
            query += `&start_${key}=${this.filtro[key]+' 00:00:00'}`;
            query += `&end_${key}=${this.filtro[key]+' 23:59:59'}`;
          }
          else if (key == 'event_entry_datetime') {
            query += `&${key}=${this.filtro[key]+' 00:00:00'}`;
          }
          else if (key == 'event_exit_datetime') {
            query += `&${key}=${this.filtro[key]+' 23:59:59'}`;
          }
          else if (key == 'dates' && this.filtro[key].length > 0) {

            if (this.filterType === 'stay') {
              query += `&event_entry_datetime=${this.filtro[key][0]} 00:00:00`;
              query += `&event_exit_datetime=${this.filtro[key][1]} 23:59:59`;
            } else {
              query += `&start_datetime=${this.filtro[key][0]} 00:00:00`;
              query += `&end_datetime=${this.filtro[key][1]} 23:59:59`;
            }
          }
          else if (this.filtro[key] === "ACTIVE" && !(['stay', 'event'].includes(this.filterType)) ) {
            query += `&is_active=1`;
          }
          else if (this.filtro[key] === "plans_id" ) {
            if (this.filtro[key].value == 'Plan custom') {
              query += `&plan_custom=1`;  // TODO: confirmar con api, filtro plan custom
            }
            query += `&${key}=${this.filtro[key]}`;
          }
          else if (key == 'clients_id') {
            query += `&${key}=${this.filtro[key].value}`;
          }
          else if ( !['dates', 'hours'].includes(key) ) {
            query += `&${key}=${this.filtro[key]}`;
          }

        }
      });

      if (this.multipleParking) {
        const parkingsToFilter = this.parkingsSelected && this.parkingsSelected.length > 0 ?
          this.parkingsSelected.map(p => p.value) : false;

        if (parkingsToFilter) {
          query += `&parkings_list=${parkingsToFilter.join()}`;
        }
      } else {

        if (this.parkingsSelected) {
          query += `&parkings_id=${this.parkingsSelected.value}`;
        }
      }

      this.$emit('getData', query);
    },
    borrarFiltro() {

      this.filtro = {...DATA_FILTER};
      this.parkingsSelected = null;

      this.$emit('getData', '')
    },

    async getParkings(){

      this.loadingParking = true;
      const resp = await fetchAllParkings().catch(e => {
        this.$refs.toast.showToast(`Error al obtener los parkings`, null, 'error', '2000');
        return
      });

      if (resp.status !== 'success') {
        this.$refs.toast.showToast(`Error al obtener los parkings`, null, 'error', '2000');
        return
      }

      const parkingAllList = [...resp.data];

      this.parkingList = parkingAllList.map( g => {
        const gr = {
          value : g.id,
          label: `${g.name}`
        }
        return gr
      });

      // this.parkingList = this.parkingList.slice();
      // this.parkingList.unshift( { value: null, label: ' - Seleccionar -'});
      this.loadingParking = false;

    },


  }
}
</script>


<style lang="scss" scoped>

.header-collapsed { 

  &:hover {
    cursor: pointer;
  }

}

</style>
